module.exports = __webpack_public_path__ + "img/landscape-3.89bc4a99.jpg";